"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DOCXParagraphItem = exports.HTMLParagraphItem = exports.HTMLParagraphItemCSS = void 0;
const react_1 = __importDefault(require("react"));
const std = __importStar(require("../../law/std"));
const util_1 = require("../../util");
const html_1 = require("../common/html");
const sentenceChildrenRun_1 = require("./sentenceChildrenRun");
const columnsOrSentencesRun_1 = require("./columnsOrSentencesRun");
const component_1 = require("../common/docx/component");
const tags_1 = require("../common/docx/tags");
const itemStruct_1 = require("./itemStruct");
const list_1 = require("./list");
const amendProvision_1 = require("./amendProvision");
const common_1 = require("../common");
exports.HTMLParagraphItemCSS = `
.paragraph-item-any {
    position: relative;
}

.paragraph-item-any > div:not(.paragraph-item-decoration-block) {
    position: relative;
}

.paragraph-item-decoration-block {
    position: absolute;
    width: calc(100% - var(--paragraph-item-indent, 0));
    left: var(--paragraph-item-indent, 0);
    height: 100%;
}

.paragraph-item-decoration-left-border {
    margin: 0 0 0 -1em;
    border-left: 0.1em solid transparent;
    width: 100%;
    height: 100%;
    transition: border-left-color 0.3s;
}

.paragraph-item-any:hover > * > .paragraph-item-decoration-left-border {
    border-left-color: rgba(255, 166, 0, 0.5);
}

${std.paragraphItemTags
    .filter(tag => tag !== "Paragraph")
    .map(tag => ".paragraph-item-" + tag).join(", ")} {
    clear: both;
}

.article-title {
    font-weight: bold;
}

.paragraph-item-title {
    font-weight: bold;
}


.paragraph-item-main {
    position: relative;
    padding-left: 1em;
    text-indent: -1em;
}
`;
const HTMLParagraphItemLeftBorder = () => {
    return react_1.default.createElement("div", { className: "paragraph-item-decoration-left-border" });
};
exports.HTMLParagraphItem = (0, html_1.wrapHTMLComponent)("HTMLParagraphItem", ((props) => {
    const { el, htmlOptions, indent, ArticleTitle } = props;
    const blocks = [];
    const ParagraphCaption = el.children.find(el => std.isParagraphCaption(el) || std.isArticleCaption(el));
    if (ParagraphCaption && std.isArticleCaption(ParagraphCaption)) {
        console.error(`unexpected element! ${JSON.stringify(ParagraphCaption, undefined, 2)}`);
    }
    const ParagraphItemTitle = el.children.find(std.isParagraphItemTitle);
    const ParagraphItemSentence = el.children.find(std.isParagraphItemSentence);
    const OldParatraphNum = ((std.isParagraph(el) && el.attr.OldNum === "true")
        ? String.fromCharCode("①".charCodeAt(0) - 1 + Number(el.attr.Num))
        : undefined);
    if (ParagraphCaption) {
        blocks.push((react_1.default.createElement("div", { className: `paragraph-caption indent-${indent + 1}`, ...(0, html_1.elProps)(ParagraphCaption, htmlOptions) },
            react_1.default.createElement(sentenceChildrenRun_1.HTMLSentenceChildrenRun, { els: ParagraphCaption.children, htmlOptions }))));
    }
    if (ParagraphItemTitle || ParagraphItemSentence) {
        blocks.push((react_1.default.createElement("div", { className: `paragraph-item-main indent-${indent}` },
            Boolean(ParagraphItemTitle || ArticleTitle || OldParatraphNum) && ((react_1.default.createElement(react_1.default.Fragment, null,
                ArticleTitle && (react_1.default.createElement("span", { className: "article-title", ...(0, html_1.elProps)(ArticleTitle, htmlOptions) },
                    react_1.default.createElement(sentenceChildrenRun_1.HTMLSentenceChildrenRun, { els: ArticleTitle.children, htmlOptions }))),
                ParagraphItemTitle && ((!ArticleTitle && !OldParatraphNum) || (ParagraphItemTitle.text().length > 0)) && (react_1.default.createElement(react_1.default.Fragment, null,
                    ArticleTitle && (react_1.default.createElement(html_1.HTMLMarginSpan, { className: "paragraph-item-margin" })),
                    react_1.default.createElement("span", { className: "paragraph-item-title", ...(0, html_1.elProps)(ParagraphItemTitle, htmlOptions) },
                        react_1.default.createElement(sentenceChildrenRun_1.HTMLSentenceChildrenRun, { els: ParagraphItemTitle.children, htmlOptions })))),
                OldParatraphNum && (react_1.default.createElement(react_1.default.Fragment, null,
                    ArticleTitle && (react_1.default.createElement(html_1.HTMLMarginSpan, { className: "paragraph-item-margin" })),
                    react_1.default.createElement("span", { className: "old-paragraph-num" },
                        react_1.default.createElement(sentenceChildrenRun_1.HTMLSentenceChildrenRun, { els: [OldParatraphNum], htmlOptions })))),
                Boolean(ParagraphItemSentence) && (react_1.default.createElement(html_1.HTMLMarginSpan, { className: "paragraph-item-margin" }))))),
            react_1.default.createElement("span", { className: "paragraph-item-body" },
                react_1.default.createElement(columnsOrSentencesRun_1.HTMLColumnsOrSentencesRun, { els: ParagraphItemSentence?.children ?? [], htmlOptions })))));
    }
    for (const child of el.children) {
        if (std.isArticleCaption(child)
            || std.isParagraphCaption(child)
            || std.isParagraphItemTitle(child)
            || std.isParagraphItemSentence(child)) {
            continue;
        }
        else if (std.isParagraphItem(child)) {
            blocks.push(react_1.default.createElement(exports.HTMLParagraphItem, { el: child, indent: indent + 1, htmlOptions })); /* >>>> INDENT >>>> */
        }
        else if (std.isTableStruct(child) || std.isFigStruct(child) || std.isStyleStruct(child)) {
            blocks.push(react_1.default.createElement(itemStruct_1.HTMLItemStruct, { el: child, indent: indent + 1, htmlOptions })); /* >>>> INDENT >>>> */
        }
        else if (std.isList(child)) {
            blocks.push(react_1.default.createElement(list_1.HTMLList, { el: child, indent: indent + 2, htmlOptions })); /* >>>> INDENT ++++ INDENT >>>> */
        }
        else if (std.isAmendProvision(child)) {
            blocks.push(react_1.default.createElement(amendProvision_1.HTMLAmendProvision, { el: child, indent: indent + 1, htmlOptions })); /* >>>> INDENT >>>> */
        }
        else if (std.isClass(child)) {
            throw new util_1.NotImplementedError(child.tag);
        }
        else {
            throw (0, util_1.assertNever)(child);
        }
    }
    const decorations = [HTMLParagraphItemLeftBorder, ...(props.decorations ?? [])];
    return (react_1.default.createElement("div", { className: `paragraph-item-${el.tag} paragraph-item-any`, ...(0, html_1.elProps)(el, htmlOptions) },
        (decorations.length > 0) && react_1.default.createElement(react_1.default.Fragment, null, decorations.map((D, i) => (react_1.default.createElement("div", { key: i, className: "paragraph-item-decoration-block", style: { ["--paragraph-item-indent"]: `${indent}em` } },
            react_1.default.createElement(D, { ...props }))))),
        (0, common_1.withKey)(blocks)));
}));
exports.DOCXParagraphItem = (0, component_1.wrapDOCXComponent)("DOCXParagraphItem", ((props) => {
    const { el, docxOptions, indent, ArticleTitle } = props;
    const blocks = [];
    const ParagraphCaption = el.children.find(el => std.isParagraphCaption(el) || std.isArticleCaption(el));
    if (ParagraphCaption && std.isArticleCaption(ParagraphCaption)) {
        console.error(`unexpected element! ${JSON.stringify(ParagraphCaption, undefined, 2)}`);
    }
    const ParagraphItemTitle = el.children.find(std.isParagraphItemTitle);
    const ParagraphItemSentence = el.children.find(std.isParagraphItemSentence);
    const OldParatraphNum = ((std.isParagraph(el) && el.attr.OldNum === "true")
        ? String.fromCharCode("①".charCodeAt(0) - 1 + Number(el.attr.Num))
        : undefined);
    if (ParagraphCaption) {
        blocks.push((react_1.default.createElement(tags_1.w.p, null,
            react_1.default.createElement(tags_1.w.pPr, null,
                react_1.default.createElement(tags_1.w.pStyle, { "w:val": `Indent${indent + 1}` })),
            react_1.default.createElement(sentenceChildrenRun_1.DOCXSentenceChildrenRun, { els: ParagraphCaption.children, docxOptions }))));
    }
    if (ParagraphItemTitle || ParagraphItemSentence) {
        blocks.push((react_1.default.createElement(tags_1.w.p, null,
            react_1.default.createElement(tags_1.w.pPr, null, (ArticleTitle || ParagraphItemTitle) ? (react_1.default.createElement(tags_1.w.pStyle, { "w:val": `IndentHanging${indent}` })) : (react_1.default.createElement(tags_1.w.pStyle, { "w:val": `IndentFirstLine${indent}` }))),
            ArticleTitle && (react_1.default.createElement(sentenceChildrenRun_1.DOCXSentenceChildrenRun, { els: ArticleTitle.children, emphasis: true, docxOptions })),
            ParagraphItemTitle && ((!ArticleTitle && !OldParatraphNum) || (ParagraphItemTitle.text().length > 0)) && (react_1.default.createElement(react_1.default.Fragment, null,
                ArticleTitle && (react_1.default.createElement(tags_1.w.r, null,
                    react_1.default.createElement(tags_1.w.t, null, component_1.DOCXMargin))),
                react_1.default.createElement(sentenceChildrenRun_1.DOCXSentenceChildrenRun, { els: ParagraphItemTitle.children, docxOptions }))),
            OldParatraphNum && (react_1.default.createElement(react_1.default.Fragment, null,
                ArticleTitle && (react_1.default.createElement(tags_1.w.r, null,
                    react_1.default.createElement(tags_1.w.t, null, component_1.DOCXMargin))),
                react_1.default.createElement(sentenceChildrenRun_1.DOCXSentenceChildrenRun, { els: [OldParatraphNum], docxOptions }))),
            Boolean((ParagraphItemTitle || ArticleTitle) && ParagraphItemSentence) && (react_1.default.createElement(tags_1.w.r, null,
                react_1.default.createElement(tags_1.w.t, null, component_1.DOCXMargin))),
            react_1.default.createElement(columnsOrSentencesRun_1.DOCXColumnsOrSentencesRun, { els: ParagraphItemSentence?.children ?? [], docxOptions }))));
    }
    for (const child of el.children) {
        if (std.isArticleCaption(child)
            || std.isParagraphCaption(child)
            || std.isParagraphItemTitle(child)
            || std.isParagraphItemSentence(child)) {
            continue;
        }
        else if (std.isParagraphItem(child)) {
            blocks.push(react_1.default.createElement(exports.DOCXParagraphItem, { el: child, indent: indent + 1, docxOptions })); /* >>>> INDENT >>>> */
        }
        else if (std.isTableStruct(child) || std.isFigStruct(child) || std.isStyleStruct(child)) {
            blocks.push(react_1.default.createElement(itemStruct_1.DOCXItemStruct, { el: child, indent: indent + 1, docxOptions })); /* >>>> INDENT >>>> */
        }
        else if (std.isList(child)) {
            blocks.push(react_1.default.createElement(list_1.DOCXList, { el: child, indent: indent + 2, docxOptions })); /* >>>> INDENT ++++ INDENT >>>> */
        }
        else if (std.isAmendProvision(child)) {
            blocks.push(react_1.default.createElement(amendProvision_1.DOCXAmendProvision, { el: child, indent: indent + 1, docxOptions })); /* >>>> INDENT >>>> */
        }
        else if (std.isClass(child)) {
            throw new util_1.NotImplementedError(child.tag);
        }
        else {
            throw (0, util_1.assertNever)(child);
        }
    }
    return (react_1.default.createElement(react_1.default.Fragment, null, (0, common_1.withKey)(blocks)));
}));
//# sourceMappingURL=paragraphItem.js.map